/**
 * Inline "Also from Snapplify" promo, rendered below the Reader picker.
 *
 * Lifted from `@snapplify/ui`'s `product-promo` primitive (visual pattern
 * + Book Buddy AI's canonical row data). When the framework is wired as
 * a submodule in a future milestone, swap this for `createProductPromo()`
 * directly. Until then, the page owns the markup but the styling reads
 * from the same `--sg-*` tokens as the framework so it skins identically.
 */

const PRODUCTS = [
    {
        id: 'book-buddy',
        name: 'Book Buddy AI',
        description:
            'Textbook-aware AI tutor — students ask questions about the specific book they’re reading.',
        accent: '#6c943e', // canonical per @snapplify/ui's product-promo docs
        href: 'https://bookbuddy.snapplify.ai/',
        cta: 'Try it',
    },
];

// Inline SVGs — no Font Awesome dep here. Mirrors fa-book-open shape;
// arrow is the standard external-link glyph.
const BOOK_SVG = `
    <svg class="sg-promo-icon-glyph" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
        <path d="M11 4.5a2 2 0 0 0-2-2H4.5A1.5 1.5 0 0 0 3 4v13a1.5 1.5 0 0 0 1.5 1.5H9a2 2 0 0 1 2 2 .5.5 0 0 0 1 0 2 2 0 0 1 2-2h4.5A1.5 1.5 0 0 0 21 17V4a1.5 1.5 0 0 0-1.5-1.5H15a2 2 0 0 0-2 2v12.586A2.99 2.99 0 0 0 12 17a2.99 2.99 0 0 0-1 .086V4.5Z"/>
    </svg>
`;

const ARROW_SVG = `
    <svg class="sg-promo-arrow" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M9 3h4v4"/>
        <path d="m13 3-6 6"/>
        <path d="M11 9.5V12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2.5"/>
    </svg>
`;

const escapeAttr = (s) =>
    String(s).replace(/[&<>"']/g, (c) => (
        {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]
    ));

function renderRow(product) {
    return `
        <a class="sg-promo-row"
           href="${escapeAttr(product.href)}"
           target="_blank"
           rel="noopener noreferrer"
           style="--sg-promo-accent: ${escapeAttr(product.accent)}">
            <span class="sg-promo-icon" aria-hidden="true">${BOOK_SVG}</span>
            <span class="sg-promo-body">
                <span class="sg-promo-name">${escapeAttr(product.name)}</span>
                <span class="sg-promo-desc">${escapeAttr(product.description)}</span>
            </span>
            <span class="sg-promo-cta">
                <span>${escapeAttr(product.cta)}</span>
                ${ARROW_SVG}
            </span>
        </a>
    `;
}

export function renderProductPromo() {
    return `
        <section class="sg-promo">
            <h2 class="sg-promo-title">Also from Snapplify</h2>
            <div class="sg-promo-list">
                ${PRODUCTS.map(renderRow).join('')}
            </div>
        </section>
    `;
}
